import "./FullPageComponentLoader.scss";

export const FullPageComponentLoader = () => {
  return (
    <div data-testid="full-page-loader">
      <p className="FullPageComponentLoader__title"></p>
      <p className="FullPageComponentLoader__row"></p>
      <p className="FullPageComponentLoader__row"></p>
      <p className="FullPageComponentLoader__row"></p>
    </div>
  );
};
